/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import NavCommon from "../../components/@navHeader";
import axiosProducts from "../../services/products";
import Body from "./components/Body";
import Carousel from "./components/Carousel";
import Header from "./components/Header";
import { Especialistas } from "./components/Especialistas";
import { Endereco } from "./components/Endereco";
import Documentos from "./components/Documentos";

interface ProductDetailInterface {
  idEmpreendimento: string;
}

const ProductDetail = () => {
  const history = useHistory();
  const params: ProductDetailInterface = useParams();
  const [loading, setLoading] = useState<boolean>(false);
  const [productsDetail, setProductsDetail] = useState<any>([]);

  const requestProductsDetails = async () => {
    setLoading(true);
    try {
      const response = await axiosProducts.GetProdutosDetail(
        `CodigoEmpreendimento=${params?.idEmpreendimento}`
      );
      setProductsDetail(response?.data.data);
    } catch (error: any) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    requestProductsDetails();
  }, []);

  return (
    <>
      <NavCommon
        breadcrumbs={[
          { path: "/produtos", name: "Produtos" },
          {
            path: "",
            name:
              productsDetail?.[0]?.nomeEmpreendimento || "Detalhes do Produto",
          },
        ]}
        onBack={() => {
          history.goBack();
        }}
        // eslint-disable-next-line prettier/prettier
        onChangeActionNew={() => {}}
      />
      <Header data={productsDetail?.[0]} nomeBandeira="CYRELA" />
      <Body data={productsDetail?.[0]} />
      <div style={{ display: "flex" }}>
        {productsDetail[0]?.pdv?.logradouro ? (
          <Endereco data={productsDetail?.[0]} />
        ) : (
          <></>
        )}
        {productsDetail[0]?.supervisores[0]?.nome ? (
          <Especialistas data={productsDetail?.[0]} />
        ) : (
          <></>
        )}
      </div>

      <Carousel data={productsDetail?.[0]?.fotosGaleria} title="Imagens" />
      <Carousel data={productsDetail?.[0]?.fotosPlantas} title="Plantas" />
      <Documentos
        pastas={productsDetail?.[0]?.documentos}
        arquivos={productsDetail?.[0]?.documentos?.arquivos}
        title="Documentos"
      />
    </>
  );
};

export default ProductDetail;
